import { Controller } from "@hotwired/stimulus"

const DAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
]

export default class extends Controller {
  static targets = ["hiddenField", "dayToggle", "startTime", "endTime"]

  connect() {
    this.syncFromHiddenField()
  }

  toggleDay(event) {
    const day = event.target.dataset.day
    const enabled = event.target.checked

    const startInput = this.startTimeTargets.find(
      (el) => el.dataset.day === day,
    )
    const endInput = this.endTimeTargets.find((el) => el.dataset.day === day)

    if (startInput) startInput.disabled = !enabled
    if (endInput) endInput.disabled = !enabled

    if (enabled && startInput && !startInput.value) startInput.value = "09:00"
    if (enabled && endInput && !endInput.value) endInput.value = "17:00"

    this.syncToHiddenField()
  }

  updateTime() {
    this.syncToHiddenField()
  }

  syncToHiddenField() {
    const hours = {}

    DAYS.forEach((day) => {
      const toggle = this.dayToggleTargets.find((el) => el.dataset.day === day)
      const start = this.startTimeTargets.find((el) => el.dataset.day === day)
      const end = this.endTimeTargets.find((el) => el.dataset.day === day)

      if (toggle && toggle.checked && start && end) {
        hours[day] = { start: start.value, end: end.value }
      } else {
        hours[day] = null
      }
    })

    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.value = JSON.stringify(hours)
    }
  }

  syncFromHiddenField() {
    if (!this.hasHiddenFieldTarget || !this.hiddenFieldTarget.value) return

    try {
      const hours = JSON.parse(this.hiddenFieldTarget.value)

      DAYS.forEach((day) => {
        const toggle = this.dayToggleTargets.find(
          (el) => el.dataset.day === day,
        )
        const start = this.startTimeTargets.find((el) => el.dataset.day === day)
        const end = this.endTimeTargets.find((el) => el.dataset.day === day)
        const config = hours[day]

        if (toggle) toggle.checked = config !== null && config !== undefined
        if (start) {
          start.disabled = !config
          if (config) start.value = config.start || "09:00"
        }
        if (end) {
          end.disabled = !config
          if (config) end.value = config.end || "17:00"
        }
      })
    } catch {
      // Invalid JSON — leave form as-is
    }
  }
}
